module.exports = __webpack_public_path__ + "static/media/ActivitySub1.4c301225.png";